let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bkOZu"), load("4fCJZ"), load("eHw9Y")]).then(() => parcelRequire('3JZ3w'));